var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconTools64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 32.5029V56.5029H11.3333C10.4129 56.5029 9.57953 56.1298 8.97631 55.5266C8.3731 54.9234 8 54.0901 8 53.1696V32.5029H32Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 32.5029V53.1696C56 54.0901 55.6269 54.9234 55.0237 55.5266C54.4205 56.1298 53.5871 56.5029 52.6667 56.5029H32V32.5029H56Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 8.50293V32.5029H8V11.8363C8 10.9158 8.3731 10.0825 8.97631 9.47924C9.57953 8.87603 10.4129 8.50293 11.3333 8.50293H32Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6667 8.50293C53.5871 8.50293 54.4205 8.87603 55.0237 9.47924C55.6269 10.0825 56 10.9158 56 11.8363V32.5029H32V8.50293H52.6667Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 20.5029H50",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38 42.5029H50",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38 46.5029H50",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2285 40.7319L23.771 48.2744",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7715 40.7319L16.229 48.2744",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.5029H26",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5029L20 26.5029",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconTools64);
export default __webpack_public_path__ + "static/media/pictogramBeaconTools64.c82397c602653b4bc432f4b4e0b22077.svg";
export { ForwardRef as ReactComponent };